// This file is automatically generated by `generated_js` task. Any changes will be lost
/* tslint:disable */
export const GoCDVersion = {
  "version": "25.3.0",
  "buildNumber": "20862",
  "gitSha": "e48df223c27445d22c88cd58e5218bebd4fa9496",
  "fullVersion": "25.3.0-20862",
  "formattedVersion": "25.3.0 (20862-e48df223c27445d22c88cd58e5218bebd4fa9496)"
}


function stripLeadingPrefix(suffix: string, prefix: string) {
  if (suffix.startsWith(prefix)) {
      suffix = suffix.substring(1);
  }
  return suffix;
}

export function docsUrl(suffix: string = '') {
  return `https://docs.gocd.org/25.3.0/${stripLeadingPrefix(suffix, '/')}`
}

export function apiDocsUrl(suffix: string = '') {
  return `https://api.gocd.org/25.3.0/${stripLeadingPrefix(suffix, '#')}`
}
    
